"use client";
import { jsx as i } from "react/jsx-runtime";
import * as m from "@radix-ui/react-switch";
import { forwardRef as s } from "react";
const c = s((t, o) => /* @__PURE__ */ i(m.Root, { "data-slot": "switch", ...t, ref: o }));
c.displayName = "SwitchRoot";
const h = s((t, o) => /* @__PURE__ */ i(m.Thumb, { "data-slot": "switch-thumb", ...t, ref: o }));
h.displayName = "SwitchThumb";
export {
  c as SwitchRoot,
  h as SwitchThumb
};
